import React, { useEffect, useRef } from "react"; // Importar useEffect e useRef
import { Navigate, useLocation } from "react-router-dom";
import Loading from "@/components/Loading";
import { showManagedToast } from "@/util/toastManager"; // Importar o utilitário de toast

/**
 * Envolve rotas que exigem operador logado.
 * – Se estiver validando, mostra um loader de tela cheia.
 * – Se não houver sessão, redireciona para /login e mostra um toast.
 */
export default function RequireAuth({ children }: { children: React.JSX.Element }) {
    const location = useLocation();
    const operator = sessionStorage.getItem("operator");
    const checking = false; // TODO: Ajuste se houver uma verificação assíncrona real da sessão (ex: API call)

    // Ref para controlar se o toast de redirecionamento já foi mostrado
    const hasShownRedirectToast = useRef(false);

    // Efeito para exibir o toast de redirecionamento se o operador não estiver logado
    useEffect(() => {
        if (!operator && !checking && !hasShownRedirectToast.current) {
            showManagedToast(
                "warning", // Ou "info", dependendo da urgência
                "Sua sessão expirou ou você não está logado. Por favor, faça login novamente.",
                "require-auth-redirect" // Chave única para este toast
            );
            hasShownRedirectToast.current = true; // Marca que o toast foi mostrado
        }
        // Se o operador estiver logado (ou se a verificação estiver em andamento), reseta a flag
        else if (operator || checking) {
            hasShownRedirectToast.current = false;
        }
    }, [operator, checking, location.pathname]); // Depende de operator, checking e pathname para reavaliar
    // 1. Se houver uma verificação assíncrona em andamento, mostra o loader
    if (checking) {
        return <Loading message="Validando sessão de operador..." />;
    }
    // 2. Se não houver operador logado, redireciona para a página de login
    if (!operator) {
        // Redireciona e substitui a entrada atual no histórico
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    // 3. Se o operador estiver logado, renderiza os filhos
    return children;
}